export default {
  name: "TypeRapidInfo",
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    showSoundFile() {
      return this.model.soundFile;
    },
    soundFile() {
      return this.model.soundFile;
    },
    title() {
      return this.model.title;
    },
    body() {
      return this.model.body;
    },
    category() {
      return this.model.category;
    }
  }
};
